"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const defaultProps = {
    active: false,
    shouldOffWhenEsc: false,
};
const ESC_KEYCODE = 27;
class Toggle extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.toggle = () => this.setState((prevState) => ({ isActive: !prevState.isActive }));
        this.on = () => this.setState({ isActive: true });
        this.off = () => this.setState({ isActive: false });
        this.handleEsc = (event) => {
            if (event.keyCode === ESC_KEYCODE) {
                this.off();
            }
        };
        this.state = {
            isActive: props.active || false,
        };
    }
    componentDidMount() {
        const { shouldOffWhenEsc } = this.props;
        if (shouldOffWhenEsc) {
            document.addEventListener('keydown', this.handleEsc);
        }
    }
    componentWillUnmount() {
        const { shouldOffWhenEsc } = this.props;
        if (shouldOffWhenEsc) {
            document.removeEventListener('keydown', this.handleEsc);
        }
    }
    render() {
        const { children } = this.props;
        const { isActive } = this.state;
        const { toggle, on, off } = this;
        if (!children) {
            return null;
        }
        return children({ isActive, toggle, on, off });
    }
}
exports.default = Toggle;
Toggle.defaultProps = defaultProps;
